import type { DateFormat, PermissionDTO, TimeFormat } from '@next-space/fe-api-idl';
import { i18n } from '@flowus/common/i18n';

export interface PickerDate {
  from: Date;
  to?: Date;
  dateFormat?: DateFormat;
  timeFormat?: TimeFormat;
  includeTime?: boolean; // 是否包含时间
  reminder?: Reminder;
  includeDateRange?: boolean;
}
export interface Reminder {
  time?: string;
  value?: number;
  unit?: 'day' | 'hour' | 'minute';
  userPermissions?: PermissionDTO[];
}
/** 因为要通过segment.reminder来算出具体的选项，因此选项的字段跟reminder里的字段保持一致 */
// unit?: 'day' | 'hour' | 'minute',
interface RemindOption {
  name: string;
  value: number;
  time?: string;
  unit?: 'day' | 'hour' | 'minute';
}
export const remindDayOptions: RemindOption[] = [
  {
    name: i18n.t('common.none'),
    value: 0,
    time: '',
  },
  {
    name: i18n.t('components.date_picker.remind_options.same_day_9am'),
    value: 0,
    time: '09:00',
    unit: 'day',
  },
  {
    name: i18n.t('components.date_picker.remind_options.1_day_before_9am'),
    value: 1,
    time: '09:00',
    unit: 'day',
  },
  {
    name: i18n.t('components.date_picker.remind_options.2_days_before_9am'),
    value: 2,
    time: '09:00',
    unit: 'day',
  },
  {
    name: i18n.t('components.date_picker.remind_options.1_week_before_9am'),
    value: 7,
    time: '09:00',
    unit: 'day',
  },
];
export const remindTimeOptions: RemindOption[] = [
  {
    name: i18n.t('common.none'),
    value: 0,
  },
  {
    name: i18n.t('components.date_picker.remind_options.at_time'),
    value: 0,
    unit: 'minute',
  },
  {
    name: i18n.t('components.date_picker.remind_options.5_minutes_before'),
    value: 5,
    unit: 'minute',
  },
  {
    name: i18n.t('components.date_picker.remind_options.10_minutes_before'),
    value: 10,
    unit: 'minute',
  },
  {
    name: i18n.t('components.date_picker.remind_options.15_minutes_before'),
    value: 15,
    unit: 'minute',
  },
  {
    name: i18n.t('components.date_picker.remind_options.30_minutes_before'),
    value: 30,
    unit: 'minute',
  },
  {
    name: i18n.t('components.date_picker.remind_options.1_hour_before'),
    value: 1,
    unit: 'hour',
  },
  {
    name: i18n.t('components.date_picker.remind_options.2_hours_before'),
    value: 2,
    unit: 'hour',
  },
  {
    name: i18n.t('components.date_picker.remind_options.1_day_before'),
    value: 1,
    unit: 'day',
  },
  {
    name: i18n.t('components.date_picker.remind_options.2_days_before'),
    value: 2,
    unit: 'day',
  },
  {
    name: i18n.t('components.date_picker.remind_options.1_week_before'),
    value: 7,
    unit: 'day',
  },
];
